import React from "react";
import Stepper from "../../../ui/stepper/Stepper";
import GuideEnd from "./usage-guide-steps/GuideEnd";
import HeatMapToggle from "./usage-guide-steps/HeatMapToggle";
import InteractionTestEnd from "./usage-guide-steps/InteractionTestEnd";
import InteractionTestStart from "./usage-guide-steps/InteractionTestStart";
import Intro from "./usage-guide-steps/Intro";
import PanelsPolarization from "./usage-guide-steps/PanelsPolarization";
import TintStatusToggle from "./usage-guide-steps/TintStatusToggle";
import "./_usage-guide.scss";

const UsageGuide = () => {
  return (
    // @ts-ignore
    <Stepper
      stepsRenderer={({ handleStepIncrease, handleStepsNavigationEnd }) => [
        <Intro
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        <PanelsPolarization
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        // <AnimationControl
        //   handleNextStep={handleStepIncrease}
        //   handleClose={handleStepsNavigationEnd}
        // />,
        <TintStatusToggle
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        <HeatMapToggle
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        // <ResetControl
        //   handleNextStep={handleStepIncrease}
        //   handleClose={handleStepsNavigationEnd}
        // />,
        <InteractionTestStart
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        <InteractionTestEnd
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
        <GuideEnd
          handleNextStep={handleStepIncrease}
          handleClose={handleStepsNavigationEnd}
        />,
      ]}
    />
  );
};

export default UsageGuide;
